<template>
  <donut-table :headers="headers" :data="coffeeConfigurations" :disabled="!tableEnabled">
    <template #channel="{ entry }">
      <div class="t single-line" :title="entry.channel?.name">
        <div v-if="entry.channel?.hidden_from_user" v-emoji="':lock:Private channel'" class="t link ul" />
        <a v-else-if="entry.channel" class="link ul" :href="`/coffee/${entry.id}/edit`" target="_blank">{{ entry.channel.name }}</a>
        <span v-else class="t gray">Channel unavailable</span>
      </div>
    </template>
    <template #creator="{ entry }">
      <onboarding-overview--team-membership
        :name="entry.creator.name"
        :avatar="entry.creator.avatar"
      />
    </template>
    <template #points="{ entry, rowIdx }">
      <donut-input-async-number
        :ref="(el) => pointsInputRefs[`points-input${rowIdx}`] = el"
        :model-value="entry.points_on_completion"
        :paywall="paywall('customize Intros points', 'num-points')"
        class="w-x12"
        @submit="(val, onComplete) => onPointsChange(entry, val, onComplete)"
        @advance="focusNextPointsInput(rowIdx + 1)"
      />
    </template>
    <template #enablePoints="{ entry }">
      <donut-input-toggle
        v-if="tableEnabled"
        :model-value="isPointsEnabled(entry)"
        :paywall="paywall('disable Intros points', 'channel-enabled')"
        update-action="pointsConfig/toggleCoffeeConfiguration"
        :update-args="{ coffeeConfiguration: entry }"
        size="small"
        :load-on-toggle="true"
      />
      <donut-input-toggle v-else :model-value="false" size="small" /> <!-- Decoy "off" toggles for when the table is turned off-->
    </template>
  </donut-table>
</template>
<script setup>
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';

  const { state, dispatch } = useStore();

  const headers = [
    { label: 'Channel', key: 'channel', weight: 15 },
    { label: 'Owner', key: 'creator', weight: 15 },
    { label: 'Points on Completion', key: 'points', weight: 15 },
    { label: 'Enable Points', key: 'enablePoints', weight: 15 },
  ];

  const coffeeConfigurations = computed(() => state.pointsConfig.config.coffee_configurations);

  const isPointsEnabled = (entry) => entry.points_on_completion > 0;
  const tableEnabled = computed(() => state.pointsConfig.config.award_points_for_intros);

  const paywall = (featureTitleText, sourceSuffix) => ({
      data: state.pointsConfig.config.upgrade_data,
      feature: 'award_points_for_intros',
      featureTitleText,
      source: `automatic-points-intros-${sourceSuffix}`,
      programKey: 'shoutouts',
    });

  // Points Input Refs
  const pointsInputRefs = ref({});
  const onPointsChange = (coffeeConfiguration, val, onComplete) => {
    if (parseInt(val) !== val || val < 0) {
      dispatch('setErrorToast', '"Points On Completion" must be a whole number.');
      onComplete({ icon: 'error', value: coffeeConfiguration.points_on_completion });
    } else {
      dispatch('pointsConfig/updateCoffeeConfiguration', { coffeeConfiguration, points: val })
        .then(() => { onComplete({ icon: 'success' }); });
    }
  };
  const focusNextPointsInput = (idx) => {
    const pointsInputEl = pointsInputRefs.value[`points-input${idx}`];
    if (pointsInputEl) pointsInputEl.open();
  };
</script>
